import type { FeatureFlag } from '@/feature-flags/FeatureEvaluator';

export const featureFlagsMockData: FeatureFlag[] = [
  {
    id: 'ff-1',
    key: 'enable-new-risk-engine',
    name: 'Enable New Risk Engine',
    description: 'Launches the updated credit valuation ML pipeline.',
    enabled: true,
    status: 'enabled',
    productId: 'credit-reports',
    environment: 'production',
    rolloutPercentage: 100,
    strategy: 'percentage',
    owner: 'sarah.jenkins',
    createdDate: '2026-01-02T09:00:00.000Z',
    lastModified: '2026-01-18T11:15:00.000Z',
    modifiedBy: 's.jenkins',
    tags: ['risk', 'ml'],
    targetRules: [
      {
        id: 'ff-1-rule-1',
        strategy: 'percentage',
        percentage: 100,
      },
    ],
  },
  {
    id: 'ff-2',
    key: 'beta-credit-dashboard',
    name: 'Beta Credit Dashboard',
    description: 'Provides high-contrast beta dashboard widgets.',
    enabled: true,
    status: 'enabled',
    productId: 'admin-portal',
    environment: 'stage',
    rolloutPercentage: 25,
    strategy: 'percentage',
    owner: 'd.anderson',
    createdDate: '2026-01-04T10:30:00.000Z',
    lastModified: '2026-01-14T08:22:00.000Z',
    modifiedBy: 'd.anderson',
    tags: ['ui', 'beta'],
    targetRules: [
      {
        id: 'ff-2-rule-1',
        strategy: 'percentage',
        percentage: 25,
      },
    ],
  },
  {
    id: 'ff-3',
    key: 'modern-navigation',
    name: 'Modern Navigation',
    description:
      'Enables advanced navigation visibility and segment targeting.',
    enabled: false,
    status: 'disabled',
    productId: null,
    environment: 'production',
    rolloutPercentage: 0,
    strategy: 'boolean',
    owner: 'elena.rostova',
    createdDate: '2025-12-15T14:00:00.000Z',
    lastModified: '2026-01-10T15:01:00.000Z',
    modifiedBy: 'e.rostova',
    tags: ['navigation'],
    targetRules: [],
  },
  {
    id: 'ff-4',
    key: 'notification-v2',
    name: 'Notification V2',
    description:
      'Activates resilient notification routing with policy fallback.',
    enabled: true,
    status: 'enabled',
    productId: 'notification-center',
    environment: 'production',
    rolloutPercentage: 75,
    strategy: 'percentage',
    owner: 's.jenkins',
    createdDate: '2025-12-27T12:30:00.000Z',
    lastModified: '2026-01-08T09:18:00.000Z',
    modifiedBy: 's.jenkins',
    tags: ['notifications'],
    targetRules: [
      {
        id: 'ff-4-rule-1',
        strategy: 'percentage',
        percentage: 75,
      },
    ],
  },
  {
    id: 'ff-5',
    key: 'embedded-reporting',
    name: 'Embedded Reporting',
    description: 'Enables report module rendering in embedded product frames.',
    enabled: true,
    status: 'enabled',
    productId: 'embedded-framework',
    environment: 'production',
    rolloutPercentage: 100,
    strategy: 'productTargeting',
    owner: 'alex.mercer',
    createdDate: '2025-12-20T11:45:00.000Z',
    lastModified: '2026-01-05T13:12:00.000Z',
    modifiedBy: 'a.mercer',
    tags: ['embedded'],
    targetRules: [
      {
        id: 'ff-5-rule-1',
        strategy: 'productTargeting',
        include: ['embedded-framework'],
      },
    ],
  },
];
